import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { orderContext } from '~/app/features/order-middleware/orderMiddleware';
import { shippingClaimContext } from '~/app/features/shipping-claim/new-claim/shippingClaimMiddleware';
import { GspClaimReason, GspReasonLabels } from '~/utils/constants';
import { makeAction, makeLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData } = makeLoader(({ context }) => {
  const order = context.get(orderContext);
  const shippingClaim = context.get(shippingClaimContext);

  return {
    reasons: order.shippingClaimReasons.map((reason) => ({
      value: reason,
      label: GspReasonLabels[reason],
    })),
    selectedReason: shippingClaim.reason,
  };
});

const formSchema = zfd.formData({
  reason: zfd.text(z.enum(GspClaimReason)),
});

export const { action, useActionResult } = makeAction(
  ({ context, formData }, appStore) => {
    const order = context.get(orderContext);
    const result = formSchema.safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Please choose one of the reasons.',
      };
    }

    appStore.dispatch(
      appStore.actions.shippingProtectionClaim.setReason(result.data.reason),
    );

    const shippingClaimAction = order.shippingClaimReasonOverrides?.find(
      (override) => override.reason === result.data.reason,
    );

    const url = shippingClaimAction ? 'shipping-issue' : 'items';

    return redirect(url);
  },
);
